import { createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
 import VueSweetalert2 from 'vue-sweetalert2';
 import 'sweetalert2/dist/sweetalert2.min.css';
 import VueGtag from 'vue-gtag';
 import ElementPlus from 'element-plus'
import 'element-plus/lib/theme-chalk/index.css'


const app = createApp(App);
app.use(store).use(router).use(ElementPlus).use(VueSweetalert2).use(VueGtag, {
    config:{ id:"G-H8E5XGXQ20"}
}).mount('#app')
